export function required (value = '') {
  if (!value.trim()) return 'Required.'
}

export function warn (value, schema, result = {}) {
  schema.properties.forEach(property => {
    if (property.properties) warn(value, property, result)
    if (property.isSection) return
    const key = property.path.join('/')
    if (property.type === 'fixed_string') {
      if (value[key].trim() !== property.default.trim()) {
        result[key] = 'Non-default value. Use at own risk.'
      }
    }
  })
  return result
}

export function validate (value, schema, result = {}) {
  let properties = schema.properties
  if (schema.isList) {
    const key = schema.path.join('/')
    const listValue = value[key] != null ? String(value[key]) : ''
    const matchingSchema = schema.properties.find(schema => schema.condition === listValue)
    properties = matchingSchema ? [matchingSchema] : []
  }
  properties.forEach(property => {
    if (property.properties) validate(value, property, result)
    if (property.isSection) return
    const key = property.path.join('/')
    if (property.type === 'file' || property.type === 'fixed_string') {
      const error = required(value[key])
      if (error) result[key] = error
    }

    if (property.isNumber) {
      if (property.isMultiValue) {
        const error = validateNumericMulti(value[key], property, result)
        if (error) result[key] = error
      } else {
        const error = validateNumeric(value[key], property, result)
        if (error) result[key] = error
      }
    }
  })
  return result
}

function validateNumericMulti (values = [], schema) {
  if (!values.length) return 'Missing value'
  const errors = values.map((value, i) => {
    return validateNumeric(value, schema)
  })
  if (errors.filter(Boolean).length) return errors
}

function validateNumeric (_value, schema) {
  const type = schema.childType || schema.type
  const value = Number(_value)
  if (_value === '' || Number.isNaN(value)) return 'Must be a number.'
  if (type.startsWith('int') && value !== Math.round(value)) {
    return 'Must be an integer.'
  }
  if (value < schema.min) return `Must be >= ${schema.min}`
  if (value > schema.max) return `Must not be > ${schema.max}`
}



// WEBPACK FOOTER //
// ../webmango-core/lib/validate.js